import Vue from 'vue'
import $bizConfig from '@/models/bizConfig.js';
import $web3js from '../web3.js';
import $erc20 from '../erc20/index.js';
import $utils from "@/lib/utils/index.js";

const contractInfo = require('./currentLocker.json')

let web3 = $web3js.getWeb3();

let contractAddress = $bizConfig.currentLockerAddress;
let contractConst = {
    contract: web3 ? new web3.eth.Contract(contractInfo.abi, contractAddress) : '',
}

const getCurrentLockerAddress = () => {
    return contractAddress;
}

const getCurrentLockerContract = () => {
    return contractConst.contract;
}

const getCurrentLockerInfo = ([_pid], options) => {
    return $web3js.call(
        getCurrentLockerContract().methods.getPoolInfo, [_pid], options,
        handlCurrentLockerInfo
    );
};

const handlCurrentLockerInfo = async(res) => {

    let index = 0;
    let pid = res[index++];
    let startTime = res[index++];
    let startBlock = res[index++];
    let depositAmount = res[index++];
    let withdrawAmount = res[index++];
    let gainedBlock = res[index++];
    let unlockedBenefit = res[index++];
    let withdrawnBenefit = res[index++];
    let pledgeToken = res[index++];
    let benefitToken = res[index++];
    let apy = res[index++];


    depositAmount = await $erc20.fromErc20Value(depositAmount, pledgeToken);
    withdrawAmount = await $erc20.fromErc20Value(withdrawAmount, pledgeToken);

    return {
        depositAmount,
        withdrawAmount,
        pledgeToken,
        apy
    };
};

const getCurrentLockerUserInfo = ([_user, _pid], options) => {
    return $web3js.call(
        getCurrentLockerContract().methods.getUserInfo, [_user, _pid], options,
        handlCurrentLockertUserInfo
    );
};

const handlCurrentLockertUserInfo = async(res) => {


    let index = 0;
    let pid = res[index++];
    let depositAmount = res[index++];
    let withdrawAmount = res[index++];
    let gainedBlock = res[index++];
    let unlockedBenefit = res[index++];
    let withdrawnBenefit = res[index++];
    let lockedCount = res[index++];


    depositAmount = await $erc20.fromErc20Value(depositAmount, $erc20.getErc20Address("DMC"));
    withdrawAmount = await $erc20.fromErc20Value(withdrawAmount, $erc20.getErc20Address("DMC"));
    unlockedBenefit = await $erc20.fromErc20Value(unlockedBenefit, $erc20.getErc20Address("DMC"));
    withdrawnBenefit = await $erc20.fromErc20Value(withdrawnBenefit, $erc20.getErc20Address("DMC"));

    return {
        depositAmount,
        withdrawAmount,
        unlockedBenefit,
        withdrawnBenefit
    };
};

const currentLockerUserDeposit = async([_pid, _amount, _contractAddress], options, callback) => {
    _amount = await $erc20.toErc20Value(_amount, _contractAddress);
    return $web3js.send(getCurrentLockerContract().methods.lock, [_pid, _amount], options, callback);
};

const currentLockerUserDepositEstimateSend = async([_pid, _amount, _contractAddress], options) => {

    _amount = await $erc20.toErc20Value(_amount, _contractAddress);


    let gasPromise = $web3js.estimateSend(getCurrentLockerContract().methods.lock, [_pid, _amount], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}

const currentLockerUserRedeem = async([_pid, _amount, _contractAddress], options, callback) => {

    _amount = await $erc20.toErc20Value(_amount, _contractAddress);

    return $web3js.send(getCurrentLockerContract().methods.redeem, [_pid, _amount], options, callback);
};

const currentLockerRedeemEstimateSend = async([_pid, _amount, _contractAddress], options) => {

    _amount = await $erc20.toErc20Value(_amount, _contractAddress);

    let gasPromise = $web3js.estimateSend(getCurrentLockerContract().methods.redeem, [_pid, _amount], options);

    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}

const currentLockerWithdraw = ([_pid], options, callback) => {
    return $web3js.send(getCurrentLockerContract().methods.withdrawIncome, [_pid], options, callback);
};

const currentLockerWithdrawEstimateSend = async([_pid], options) => {
    let gasPromise = $web3js.estimateSend(
        getCurrentLockerContract().methods.withdrawIncome, [_pid], options
    );
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}

export default {
    getCurrentLockerAddress,
    getCurrentLockerContract,
    getCurrentLockerInfo,
    getCurrentLockerUserInfo,
    currentLockerUserDeposit,
    currentLockerUserDepositEstimateSend,
    currentLockerUserRedeem,
    currentLockerRedeemEstimateSend,
    currentLockerWithdraw,
    currentLockerWithdrawEstimateSend
}



// WEBPACK FOOTER //
// ./src/lib/contract/currentLocker/index.js